import { EnumsInterface } from "@/interfaces/EnumsInterface";

const ResidenceType:EnumsInterface[] = [
    {id: 0, value: 0, label: "Present"},
    {id: 1, value: 1, label: "Temporary"},
    {id: 2, value: 2, label: "Permanent"},
    {id: 3, value: 3, label: "Others"},
]

export default ResidenceType